import { buildPaymentLinkUrl } from 'lib/helpers/paymentLink';

import Input from 'components/shared/Input/Input';
import QrCode from 'components/shared/QrCode/QrCode';
import Button from 'components/shared/Button/Button';
import { showAlert } from 'components/shared/Alert/Alert';

const PaymentLinkShare = ({ practice }) => {
  const url = buildPaymentLinkUrl(practice);
  if (!url) return null;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      showAlert({ title: 'Payment link copied', color: 'success' });
    } catch {
      showAlert({
        title: "Couldn't copy the link. Select it and copy it instead.",
        color: 'danger'
      });
    }
  };

  return (
    <div className="flex items-start gap-4 sm:flex-col">
      <QrCode
        value={url}
        size={112}
        className="shrink-0 rounded-lg border border-solid border-neutral-200 p-1"
      />
      <div className="flex min-w-0 flex-1 flex-col gap-2">
        <Input
          label="Payment link"
          value={url}
          readOnly
          id="payment-link-url"
          name="paymentLinkUrl"
        />
        <Button
          text="Copy link"
          icon="copy-mono"
          size="small"
          variant="secondary"
          className="w-fit"
          onClick={copyLink}
        />
      </div>
    </div>
  );
};

export default PaymentLinkShare;
